import { render, staticRenderFns } from "./overseasCertificate.vue?vue&type=template&id=1ed977da&scoped=true&"
import script from "./overseasCertificate.vue?vue&type=script&lang=js&"
export * from "./overseasCertificate.vue?vue&type=script&lang=js&"
import style0 from "./overseasCertificate.vue?vue&type=style&index=0&id=1ed977da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed977da",
  null
  
)

export default component.exports